import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import * as R from "ramda";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";

class MasterPenjualanFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // cabangOptions: [],
            cabangOptions: this.props.cabangOptions,
        };
    }

    async componentDidMount() {
        // let response = await fetchDataAsync({
        //     asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        //     menuName: "Master Sales",
        //     setError: this.props.setError,
        //     args: null,
        // });
        // if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        //     this.setState((prevValue) => ({
        //         ...prevValue,
        //         cabangOptions: response.data.data.map((d) => mapToObjectDDL(d.namaDealer, d.kodeCabang)),
        //     }));
        // }
    }

    getFilterDataValue = (fieldName, fallbackValue = "") => {
        return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
            ? this.props.state.filterData[fieldName]
            : fallbackValue;
    };

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.state.filterVisible}
                onClickClose={this.props.onClickClose}
                content={
                    <ModalContainer>
                        <form onSubmit={this.props.onSubmit}>
                            <SimpleInput
                                id="input_text_username_tl"
                                name="userNameLead"
                                label="Username Team Lead"
                                value={this.getFilterDataValue("userNameLead")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_nama_tl"
                                name="salesLeadName"
                                label="Nama Team Lead"
                                value={this.getFilterDataValue("salesLeadName")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <SimpleDDL
                                id="select_options_nama_cabang"
                                box="search"
                                name="kodeCabang"
                                label="Nama Cabang"
                                isClearable
                                options={this.state.cabangOptions}
                                value={this.getFilterDataValue("kodeCabang", null)}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <SimpleInput
                                id="input_text_username_sales"
                                name="userNameSales"
                                label="Username Sales"
                                value={this.getFilterDataValue("userNameSales")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_nama_sales"
                                name="salesName"
                                label="Nama Sales"
                                value={this.getFilterDataValue("salesName")}
                                onChange={({target}) => this.props.onValueChange(target.name, target.value)}
                            />
                            <FlexView hAlignContent="center" vAlignContent="center">
                                <SimpleButton type="button" secondary onClick={this.props.onReset}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton type="submit">Terapkan</SimpleButton>
                            </FlexView>
                        </form>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterPenjualanFilter;
